import { createFileRoute } from '@tanstack/react-router';

import { getJobPositionQueryOptions } from '@/_pages/settings/job-positions/api-service';
import Loading from '@/_pages/settings/job-positions/profile/loading';

export const Route = createFileRoute('/_private/settings/job-positions/_template/$id/')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getJobPositionQueryOptions(opts.params.id)),
  staticData: {
    pageTitle: 'Job Position',
    tabKey: 'settings/job-position/profile',
  },
  pendingComponent: Loading,
});
